import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { useDispatch } from 'react-redux';
import { offersApi } from '../services/offersApi';
import { availabilityApi } from '../services/availabilityApi';
import { cmsConfigApi } from '../services/cmsConfigApi';
import { propertyCodesApi } from '../services/propertyCodesApi';
import { quoteReducer } from '../quote/quoteSlice';
export const store = configureStore({
    reducer: {
        [offersApi.reducerPath]: offersApi.reducer,
        [availabilityApi.reducerPath]: availabilityApi.reducer,
        [cmsConfigApi.reducerPath]: cmsConfigApi.reducer,
        [propertyCodesApi.reducerPath]: propertyCodesApi.reducer,
        quote: quoteReducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware()
        .concat(offersApi.middleware)
        .concat(availabilityApi.middleware)
        .concat(cmsConfigApi.middleware)
        .concat(propertyCodesApi.middleware)
});
setupListeners(store.dispatch);
export const useAppDispatch = useDispatch;
